<template>
  <AnnualBudgetTotalCard v-if="isRealtime" content-theme="info" data-cy="summary-box" />

  <MoleculeFrameCard v-else spacing="sm" content-theme="info">
    <div class="flex items-center" data-cy="summary-box">
      <AtomPicto name="bill" size="md" />

      <div class="flex flex-col">
        <AtomText
          :text="t('subscription.informationsSummary.summaryBox.linear.label')"
          font-size="text-sm"
          font-style="font-medium"
          color-variant="label"
        />

        <div class="flex items-baseline gap-1">
          <AtomText
            is-tag="span"
            font-style="font-bold"
            font-size="text-3xl"
            color-variant="text"
            :text="formatEuroPrice(getCurrentDirectDebit?.selectedLinearMonthlyPayment ?? null)"
            data-cy="summary-box-amount"
          />

          <AtomText
            is-tag="span"
            font-size="text-sm"
            :text="t('subscription.informationsSummary.summaryBox.linear.unit')"
            color-variant="text"
          />
        </div>
      </div>
    </div>
  </MoleculeFrameCard>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import { useSubscriptionStore } from '@/stores';

import { formatEuroPrice } from '@/utils/format.util';

import AnnualBudgetTotalCard from '@/components/subscription/BudgetSchedule/AnnualBudgetTotalCard.component.vue';

import { EDirectDebitMode } from '@/constants/subscription.constants';

const { t } = useI18n();

const { getCurrentDirectDebit } = storeToRefs(useSubscriptionStore());

const isRealtime = computed(() => getCurrentDirectDebit.value?.mode === EDirectDebitMode.REALTIME);
</script>
